export const Input = ({
    label,
    error,
    helper,
    icon,
    iconPosition = 'left',
    className = '',
    containerClassName = '',
    ...props
}) => {
    const IconComponent = icon;

    return (
        <div className={containerClassName}>
            {label && (
                <label className="block text-sm font-medium text-gray-700 mb-2">
                    {label}
                </label>
            )}
            <div className="relative">
                {icon && iconPosition === 'left' && (
                    <IconComponent className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                )}
                <input
                    className={`
            w-full px-3 py-2.5 border border-gray-300 rounded-lg
            focus:ring-2 focus:ring-blue-500 focus:border-transparent
            disabled:bg-gray-50 disabled:text-gray-500
            ${icon && iconPosition === 'left' ? 'pl-10' : ''}
            ${icon && iconPosition === 'right' ? 'pr-10' : ''}
            ${error ? 'border-red-300 focus:ring-red-500' : ''}
            ${className}
          `}
                    {...props}
                />
                {icon && iconPosition === 'right' && (
                    <IconComponent className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                )}
            </div>
            {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
            {helper && !error && <p className="mt-1 text-sm text-gray-500">{helper}</p>}
        </div>
    );
};

export default Input;